import { useCallback } from 'react';
import { appStore } from '../stores/AppStore';
import { Theme } from '../stores/ThemeStore';

export const useTheme = () => {
  const toggleTheme = useCallback(() => {
    const newTheme: Theme = appStore.theme.theme === 'dark' ? 'light' : 'dark';
    appStore.theme.setTheme(newTheme);
  }, []);

  return {
    theme: appStore.theme.theme,
    isDark: appStore.theme.isDark,
    setTheme: appStore.theme.setTheme,
    toggleTheme
  };
};

export default useTheme; 